import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const auditoria = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/tabla`
    ,
    state: {
        versionado: [],
        versionados: [],
        tablas: [],
        historicos: []
    }
}).put({
    action: "put_auditoriatabla",
    path: function (obj) {
        return `/versionado/${obj.idtabla}`;
    }, 
    onSuccess: (state, payload ) => {
        state.versionados = payload.data;
    }
}).put({
    action: "put_soportesversion",
    path: function (obj) {
        return `/soportesversion/${obj.idtabla}`;
    }, 
    onSuccess: (state, payload ) => {
        state.versionados = payload.data;
    }
}).get({
    action: "get_soportesversion",
    path: function (obj) {
        return `/soportesversion/${obj.idtabla}/${obj.idradicado}/${obj.idregistro}`;
    }, 
    onSuccess: (state, payload ) => {
        state.versionados = payload.data;
    }
}).put({
    action: "put_historicoversionado",
    path: function (obj) {
        return `/historico/${obj.idversionado}`;
    }, 
    onSuccess: (state, payload ) => {
        state.historicos = payload.data;
    }
}).get({
    action: "get_tablas",   
    onSuccess: (state, payload ) => {
        state.tablas = payload.data;
    }
}).get({
    action: "get_ultimoversionadotabla",   
    path: function (obj) {
        return `/ultimoversionado/${obj.idtabla}`;
    }, 
    onSuccess: (state, payload ) => {
        state.versionado = payload.data;
    }
}).getStore();

auditoria.getters = {
    gversionado: state => {
        return state.versionado
    },
    gversionados: state => {
        return state.versionados
    },
    ghistoricos: state => {
        return state.historicos
    },
    gtablas: state => {
        return state.tablas.filter(p=> p.visible == true);
    }
}

export default auditoria;